/**
 * @author Matthew Rogers.
 */
var ActionMenuController = (function () {
    function ActionMenuController(config, Dialog, status, topic, $state, settings, env, socket, $scope, admin, notify) {
        var _this = this;
        this.config = config;
        this.Dialog = Dialog;
        this.status = status;
        this.topic = topic;
        this.$state = $state;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.notify = notify;
        this.codesLoaded = false;
        this.showDisputeList = true;
        this.scopeUpdateSubstatus = 'actionmenu.substatus.update';
        this.invFlagUpdateBackendModuleName = 'detail/validation/substatusUpdate';
        this.getNewUIInfo = {
            uiVersion: _.get(this.topic.checksData, 'uiVersion', 1)
        };
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_5 = 5;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (_this.moveToPaidData && _this.moveToPaidData.isMoveToPaidAction && data[0] === 'invoice_flags') {
                _this.topic.sendForUpdate(['status'], 'Change Status To Paid', _this.moveToPaidData.comment, false);
                _this.moveToPaidData.isMoveToPaidAction = false;
            }
        });
        this.socket.forward('eligibility.updateInboundCMR', this.$scope);
        this.$scope.$on('socket:eligibility.updateInboundCMR', function (event, data) {
            var result = data;
            if (data.statusCode === 200) {
                var desc = '';
                var cmrNumberDescription = "CMR changed from '" + result.oldCMR + "' to '" + result.CMR + "' ";
                var dcidDescription = "DCID changed from '" + result.oldDCID + "' to '" + result.DCID + "' ";
                if (_.isString(result.CMR) && result.CMR !== '') {
                    desc += cmrNumberDescription;
                }
                if (_.isString(result.DCID) && result.DCID !== '') {
                    desc += dcidDescription;
                }
                var newHistory = _this.status.getNewHistoryObject('Override CMR Change', desc, '-', '');
                var data_1 = {
                    id: _this.topic.topic._id,
                    data: (_a = {},
                        _a['status.history'] = {
                            push: true,
                            data: [newHistory]
                        },
                        _a
                    ),
                    type: ['status']
                };
                // Send for update
                _this.topic.updateServerTopic('couchUpdate', data_1, true);
                //this.topic.reloadDisbursement(this.topic.topic._id.split('DMT-')[1]);
                _this.notify.success('CMR data successfully updated, please reload page');
            }
            else {
                _this.notify.error(data);
            }
            var _a;
        });
        this.socket.forward('eligibility.remapEmbargoCheck', this.$scope);
        this.$scope.$on('socket:eligibility.remapEmbargoCheck', function (event, data) {
            if (data.success) {
                _this.topic.reloadDisbursement(_this.topic.topic._id.split('DMT-')[1]);
                _this.notify.success('Embargo Check passed, please reload page');
            }
            else {
                _this.notify.error(data.error);
            }
        });
        this.socket.forward('eligibility.confirmCrossBoardEligibility', this.$scope);
        this.$scope.$on('socket:eligibility.confirmCrossBoardEligibility', function (event, data) {
            if (data.success) {
                _this.topic.reloadDisbursement(_this.topic.topic._id.split('DMT-')[1]);
                _this.notify.success('Cross Border Eligibility confirmed');
            }
            else {
                _this.notify.error(data.error);
            }
        });
        this.socket.forward('eligibility.loadNotification', this.$scope);
        this.$scope.$on('socket:eligibility.loadNotification', function (event, data) {
            if (data.success) {
                _this.notify.success('BP Notification Preview loaded');
                _this.topic.mailPreview = data.previewInfo;
                _this.status.openNotificationPreviewDialog(event, _this.topic, function (err) {
                    if (!err) {
                        _this.topic.sendNotification({
                            opportunityId: _this.topic.topic._id.substring(4),
                            mailData: _this.topic.mailPreview,
                            country: _this.topic.topic.country,
                            statusInfo: {
                                status: _this.topic.topic.status.status_no,
                                subStatus: _this.topic.topic.status.sub_status_no
                            },
                            incentiveGoeDecision: _.get(_this, 'topic.topic.goe.picked', 'Unknown'),
                            isPublicTender: _this.topic.topic.isPublicTender,
                            version: _this.topic.topic.version
                        });
                    }
                });
            }
            else {
                _this.notify.error(data.error);
            }
        });
        this.socket.forward('eligibility.sendNotification', this.$scope);
        this.$scope.$on('socket:eligibility.sendNotification', function (event, data) {
            if (data.success) {
                _this.notify.success('BP Notification sent successfully');
            }
            else {
                _this.notify.error(data.error);
            }
        });
        this.socket.forward('eligibility.refreshSiteIds', this.$scope);
        this.$scope.$on('socket:eligibility.refreshSiteIds', function (event, data) {
            _this.topic.siteIdData = data;
            _this.notify.success('Refreshed Passport Advantage Site Numbers');
        });
        this.socket.forward('config.getListOfAllDisputes', this.$scope);
        this.$scope.$on('socket:config.getListOfAllDisputes', function (event, data) {
            _this.codesLoaded = true;
            if (data.error) {
                return _this.notify.error("Unable to load table data => " + data.error);
            }
            // Output dispute list and filter out oppy which is equal to opened in the browser
            data.data = data.data.filter(function (oppy) { return oppy !== _this.topic.topic._id; });
            _this.reasonCodes = data;
        });
        // this.socket.forward('config.copyOppData', this.$scope);
        // this.$scope.$on('socket:config.copyOppData', (event: ng.IAngularEvent, res: any) => {
        //     if (res.err) {
        //         console.error(res.err);
        //         return this.notify.error(`Error happened while coping opportunity: ${res.err.message}`);
        //     } else {
        //         console.info(res.data);
        //         return this.notify.success(`Copying succeeded.`);
        //     }
        // });
    }
    /**
     * Need to add bold style for parent oppy in dispute list
     * @param {string} element
     * @returns {object}
     */
    ActionMenuController.prototype.setBoldStyleToParent = function (element) {
        if (element === this.topic.topic.dispute_details.parent) {
            return {
                'font-weight': '500'
            };
        }
    };
    ActionMenuController.prototype.getListOfAllDisputes = function () {
        this.showDisputeList = false;
        var disputeData = {
            originalOppy: this.topic.topic.opp,
            parentOppy: this.topic.topic.dispute_details.parent
        };
        this.admin.getListOfAllDisputes(disputeData);
    };
    ActionMenuController.prototype.viewDispute = function (event, dispute_id) {
        this.$state.go('detail.general', {
            id: dispute_id.substring(4)
        });
    };
    ActionMenuController.prototype.newLine = function (index, cols) {
        return index % cols === 0;
    };
    ActionMenuController.prototype.dispute = function (event) {
        var _this = this;
        var types = [
            { name: 'Dispute', desc: 'For situations where the Business Partner is disputing the Rejection or Payment details' },
            { name: 'Appeal', desc: 'For situations where the Business Partner is disputing the GOE decision' },
            { name: 'Exception', desc: 'For situations where an approved exception has been granted by Finance' },
            { name: 'Investment Review', desc: 'For situations where Business Partner is requesting additional review of the eligibility decision of his deal registration' },
            { name: 'Clawback', desc: 'For situations where IBM needs to recover issued bonus' },
            { name: 'Out of Policy', desc: 'For situations where an Out of Policy claim has been raised and approved' }
        ];
        var copySections = {
            'swdr': [
                { section: 'Attachments' },
                { section: 'Comments' },
                { section: 'BP Authorization Check Results' },
                { section: 'Incentive Government Check Results' },
                //{ section: 'Customer Designation' },
                { section: 'BP Duplicate Check' },
            ],
            '3': [
                { section: 'Completeness Checklist' },
                { section: 'Government Check Results' },
                { section: 'Duplicate Check Results' },
                { section: 'Eligibility Attachments' },
                { section: 'Comments' }
            ],
            '4': [
                { section: 'Validation Attachments' },
                { section: 'Comments' }
            ]
        };
        if (!this.isVersion5AndMore()) {
            copySections['swdr'].push({ section: 'Customer Designation' });
            if (!this.isVersion4AndMore()) {
                copySections['swdr'].push({ section: 'IBM Duplicate Check' });
                copySections['swdr'].push({ section: 'New Client Determination' });
            }
        }
        var statusMap = { 3: [3], 4: [3, 4] };
        var isOppyValRejected;
        var stats = [];
        var CVRType = [];
        var incents;
        if (this.isVersion4AndMore()) {
            incents = ['SSA', 'Solution', 'Focus', 'Growth', 'Ctl'];
        }
        else {
            incents = ['SSA', 'Solution', 'NewClient'];
        }
        var currStatusDesc = this.config.getMainStatusByMainStatusNo(this.topic.topic.status.status_no).txt;
        var validationRules;
        var lastStatus;
        var sapResultSrc;
        if ([8, 9].includes(this.topic.topic.status.status_no)) {
            // If Closed or Rejected
            var field = this.topic.topic.status.status_no === 8
                ? ['rejection_details', 'reject_status']
                : ['close_details', 'close_status'];
            lastStatus = this.topic.topic.status[field[0]] && this.topic.topic.status[field[0]][field[1]]
                ? this.topic.topic.status[field[0]][field[1]]
                : 3;
        }
        else {
            // If Paid (7) or Validation (4)
            lastStatus = this.topic.topic.status.status_no;
        }
        var lastStatusDesc = this.config.getMainStatusByMainStatusNo(lastStatus).txt;
        // Create solutionDecision object with incents and bool: false, for each one
        _.forEach(incents, function (e) {
            CVRType.push({ name: e, bool: false });
        });
        // Add true in current checkbox
        switch (this.topic.topic.solutionDecision) {
            case 'Solution and SSA':
                CVRType[0].bool = true;
                break;
            case 'Solution only':
                CVRType[1].bool = true;
                break;
            default: CVRType[0].bool = true;
        }
        //If calc had been started, add attachments option, too
        // TODO: update for calculation v2
        if (this.topic.topic.calculation) {
            copySections['4'].push({ section: 'Calculation & Payment Attachments' });
        }
        //Get the available statuses based on the last status (if rejected or closed) or current status if Paid
        var newStartStatuses = statusMap[lastStatus] || [3, 4];
        // Check if oppty was rejected in validation
        if (this.topic.topic.status.status_no === 8 && this.topic.topic.status.sub_status_no === 4) {
            isOppyValRejected = true;
            validationRules = false;
        }
        else {
            isOppyValRejected = false;
            validationRules = true;
        }
        angular.forEach(newStartStatuses, function (stat) {
            stats.push({ no: stat, txt: _this.config.getMainStatusByMainStatusNo(stat).txt });
        });
        var dCodes = this.settings.misc_codes.dispute_codes.codes.reduce(function (dCodes, code) {
            !dCodes[code.type]
                ? Object.assign(dCodes, (_a = {}, _a[code.type] = [code], _a))
                : dCodes[code.type].push(code);
            return dCodes;
            var _a;
        }, {});
        // Get the program profile dispute codes
        // let's be sure calculation object is there, and sapResult... it may not be if rejected pre Validation
        // const dCodes: any = this.settings.getProgramProfile(this.topic.topic.program).dispute_codes; // old logic
        // TODO: update for calculation v2
        if (this.topic.topic.calculation && this.topic.topic.calculation.sapResult) {
            sapResultSrc = typeof this.topic.topic.calculation.sapResult === 'string'
                ? this.topic.topic.calculation.sapResult.replace(/[']/g, '')
                : this.topic.topic.calculation.sapResult;
        }
        else {
            sapResultSrc = null;
        }
        // Validate swdr sections
        var checkExistence = this.topic.checksData.checkExistence;
        var swdrValidatedSects = {
            'BP Authorization Check Results': !checkExistence.checks,
            'Incentive Government Check Results': false,
            //'Customer Designation': !checkExistence.checks,
            'BP Duplicate Check': !checkExistence.DUP_MySA_check,
            'Attachments': false,
            'Comments': false
        };
        if (!this.isVersion5AndMore()) {
            swdrValidatedSects['Customer Designation'] = !checkExistence.checks;
            if (!this.isVersion4AndMore()) {
                swdrValidatedSects['IBM Duplicate Check'] = !checkExistence.DUP_SC_check;
                swdrValidatedSects['New Client Determination'] = !checkExistence.NC_check;
            }
        }
        var items = {
            disBundle: {
                uiVersion: this.topic.topic.version,
                CVRType: CVRType,
                currStatus: currStatusDesc,
                disputeCode: dCodes[types[0].name][0],
                disputeCodes: dCodes,
                disputeType: types[0],
                id: this.topic.topic._id,
                Itrtype: 'C',
                lastStatus: lastStatusDesc,
                lastStatusNo: lastStatus,
                paid: this.topic.topic.status.status_no === 7 ? true : false,
                sapResult: sapResultSrc,
                sections: copySections,
                sects2: {},
                swdrValidatedSects: swdrValidatedSects,
                swdrSects: {},
                status: stats[stats.length - 1],
                statuses: stats,
                types: types,
                isOppyValRejected: isOppyValRejected,
                validationRules: validationRules,
                solutionDecision: this.topic.topic.solutionDecision
            }
        };
        if (this.topic.topic.version && this.topic.topic.version >= 3 && items.disBundle.status.txt === 'Eligibility') {
            for (var sect in swdrValidatedSects) {
                if (swdrValidatedSects[sect]) {
                    items.disBundle.swdrSects[sect] = true;
                }
            }
        }
        this.Dialog.updateValidForm(event, items, 'dispute-dialog.html').then(function (dResult) {
            if (dResult.locals.disBundle.solutionDecision === 'Solution only') {
                for (var _i = 0, _a = dResult.locals.disBundle.CVRType; _i < _a.length; _i++) {
                    var element = _a[_i];
                    if ((element.name !== 'Solution' && element.name !== 'Engagement') && element.bool) {
                        dResult.disBundle.status.no = 3;
                    }
                }
            }
            // If Eligibility was selected, remove cvrTypes array and validationRules
            if (dResult.locals.disBundle.status.no === 3) {
                delete dResult.disBundle.CVRType;
                dResult.disBundle.validationRules = false;
            }
            // Filter out unnecessary checkboxes
            if (dResult.locals.disBundle.status.no === 4) {
                dResult.disBundle.CVRType = dResult.disBundle.CVRType.filter(function (e) { return e.bool; });
            }
            if (!angular.isUndefined(dResult)) {
                //Get the sub-status based on the new status and the Pending BPSO
                var newSubStatus = _this.config.getSubStatusByDesc(dResult.locals.disBundle.status.no, 'Pending BPSO');
                dResult.locals.disBundle.substatus = newSubStatus;
                console.info(dResult.locals.disBundle);
                _this.status.disableApproveButtons = true;
                _this.status.createDispute(dResult.locals.disBundle);
            }
        }).catch(function () {
            _this.status.disableApproveButtons = false; //User cancelled
        });
    };
    ActionMenuController.prototype.refreshChecklists = function (event) {
        var _this = this;
        var checklists = [{ name: 'Completeness Checklist', cl: 'complcl', stats: [3], refresh: false, info: 'Eligibility Tab' },
            { name: 'GOE Checklist', cl: 'complcl2', stats: [3], refresh: false, info: 'Eligibility Tab' },
            { name: 'Duplicate Search Checklist', cl: 'complcl3', stats: [3], refresh: false, info: 'Eligibility Tab' },
            { name: 'Validation Checklist', cl: 'complcl_validation', stats: [3, 4], refresh: false, info: 'Sales Order Validation Tab' },
            { name: 'Calculation Checklist', cl: 'complcl_calculation', stats: [3, 4], refresh: false, info: 'Calculation & Payment Tab' },
            { name: 'Payment Checklist', cl: 'complcl_payment', stats: [3, 4], refresh: false, info: 'Calculation & Payment Tab' },
        ];
        var items = {
            chkBundle: {
                selected: 0,
                //Function to count how many selected...probably a fancy way to do this
                tick: function (ckkBundle) {
                    ckkBundle.selected = 0;
                    ckkBundle.cls.forEach(function (cl) {
                        if (cl.refresh) {
                            ckkBundle.selected++;
                        }
                    });
                },
                status_no: this.topic.topic.status.status_no,
                cls: checklists,
                newLine: function (index, cols) {
                    if (index % cols === 0) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            }
        };
        this.Dialog.updateValidForm(event, items, 'refreshcl-dialog.html').then(function (dResult) {
            //Build the object to be sent
            var chkBundle = {
                id: _this.topic.topic._id,
                cls: [],
                comments: dResult.locals.chkBundle.comments,
                bID: _this.topic.topicBrowserID //Need this to be able to utilise the update.partial socket
            };
            angular.forEach(dResult.locals.chkBundle.cls, function (checklist) {
                if (checklist.refresh) {
                    chkBundle.cls.push(checklist);
                }
            });
            _this.status.disableApproveButtons = true;
            _this.status.refreshChecklists(chkBundle);
        }).catch(function () {
            _this.status.disableApproveButtons = false; //User cancelled
        });
    };
    ActionMenuController.prototype.resolveError = function (event) {
        var _this = this;
        this.topic.setTempFromTopicPart('errors');
        this.status.resolveError(event, this.topic.temp.errors, function (err, resolveBundle) {
            if (!err) {
                _this.topic.temp.errors = resolveBundle.errors;
                _this.topic.sendForUpdateGeneral(['errors'], true, false);
            }
        });
    };
    ActionMenuController.prototype.rollBack = function (event) {
        var _this = this;
        this.status.rollbackStatus(event, this.topic, function (err, rollBundle) {
            if (!err) {
                _this.topic.sendForUpdate(['status'], rollBundle.action, rollBundle.comments, false);
            }
        });
    };
    ActionMenuController.prototype.updatePaymentDetails = function (event) {
        var _this = this;
        this.status.updatePaymentDetailsStatus(event, this.topic, function (err, locals) {
            if (!err) {
                _this.topic.updateServerTopic('updatePaymentDetails', locals, true);
            }
        });
    };
    ActionMenuController.prototype.moveToPaid = function (event) {
        var _this = this;
        this.status.moveToPaidStatus(event, this.topic, function (err, locals) {
            if (!err) {
                var updateObject = {
                    data: (_a = {},
                        _a['invoice_flags'] = {
                            add: true,
                            data: _this.topic.temp.invoice_flags
                        },
                        _a
                    ),
                    editOption: undefined,
                    id: _this.topic.topic._id,
                    type: ['invoice_flags']
                };
                _this.moveToPaidData = {
                    isMoveToPaidAction: true,
                    comment: locals.action
                };
                _this.topic.updateServerTopic('couchUpdate', updateObject, true); // Send it to be saved
            }
            var _a;
        });
    };
    ActionMenuController.prototype.overrideProspectCMR = function (event) {
        var _this = this;
        var item = {
            message: 'Please confirm the CMR should be overridden:',
            dialogName: 'CMR Prospect Override'
        };
        this.status.overrideProspectCMRs(item, event, this.topic, function (err, locals) {
            if (!err) {
                var cmrData = {
                    CMR: locals.CMR,
                    DBG: locals.DBG,
                    DCID: locals.DCID,
                    oldDCID: _this.topic.topic.version >= _this.OPP_VERSION_5 ?
                        _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrDomesticClientId') :
                        _this.getAccountValue('domesticClientId'),
                    oldCMR: _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.incentiveCMRNumber'),
                    id: _this.topic.topic._id.split('DMT-')[1],
                    isAutomaticCheck: locals.isAutomaticCheck,
                    isOverride: locals.isOverride,
                    version: _this.topic.topic.version
                };
                _this.topic.updateChecksResults(cmrData);
            }
        });
    };
    ActionMenuController.prototype.getAccountValue = function (accountName) {
        var generics = _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.generics');
        var accountObj = generics.find(function (generic) { return generic.name === accountName; });
        return accountObj ? accountObj.value : '';
    };
    ActionMenuController.prototype.CmrCdidOverride = function (event) {
        var _this = this;
        var item = {
            message: 'Please confirm the CMR/CDID should be update:',
            dialogName: 'Update CMR/DCID'
        };
        this.status.overrideProspectCMRs(item, event, this.topic, function (err, locals) {
            if (!err) {
                var cmrData = {
                    CMR: locals.CMR,
                    DBG: locals.DBG,
                    DCID: locals.DCID,
                    oldDCID: _this.topic.topic.version >= _this.OPP_VERSION_5 ?
                        _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrDomesticClientId') :
                        _this.getAccountValue('domesticClientId'),
                    oldCMR: _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.incentiveCMRNumber'),
                    id: _this.topic.topic._id.split('DMT-')[1],
                    isAutomaticCheck: locals.isAutomaticCheck,
                    isOverride: locals.isOverride,
                    version: _this.topic.topic.version
                };
                _this.topic.updateChecksResults(cmrData);
            }
        });
    };
    ActionMenuController.prototype.passEmbargoCheck = function (event) {
        var _this = this;
        this.status.passEmbargoCheck(event, this.topic, function (err) {
            if (!err) {
                _this.topic.remapAllChecks({ id: _this.topic.topic._id.substring(4) });
            }
        });
    };
    ActionMenuController.prototype.openNotificationPreview = function (event) {
        this.topic.loadNotificationPreview({
            id: this.topic.topic._id.substring(4),
            templateId: this.topic.topic.bpNotificationTemplateInfo.templateId
        });
    };
    ActionMenuController.prototype.passCrossBoardEmeaCheck = function (event) {
        var _this = this;
        this.status.passCrossBoardEmeaCheck(event, this.topic, function (err) {
            if (!err) {
                _this.topic.confirmCrossBoardEligibility({ id: _this.topic.topic._id.substring(4) });
            }
        });
    };
    ActionMenuController.prototype.passCountryManualReview = function (event) {
        var _this = this;
        this.status.passCountryManualReview(event, this.topic, function (err) {
            if (!err) {
                _this.topic.remapAllChecks({ id: _this.topic.topic._id.substring(4) });
            }
        });
    };
    ActionMenuController.prototype.updateReAssignUser = function (event) {
        var _this = this;
        this.status.reAssignUser(event, this.topic, function (err, locals) {
            if (!err) {
                _this.topic.updateServerTopic('updateReAssignUser', locals, true);
            }
        });
    };
    ActionMenuController.prototype.close = function (event) {
        var _this = this;
        this.status.closeDisbursement(event, this.topic, function (err, closeBundle) {
            if (!err) {
                _this.topic.sendForUpdate(['status'], closeBundle.action, closeBundle.comments, false);
            }
        });
    };
    ActionMenuController.prototype.rej = function (event) {
        var _this = this;
        this.status.rejectDisbursement(event, this.topic, function (err, rejBundle) {
            if (!err) {
                _this.topic.sendForUpdate(['status'], rejBundle.action, rejBundle.comments, false);
            }
        });
    };
    /**
     * Need to ensure the approval amount in USD is set...if not, user need to refresh calcs
     * in order to set them.  This should all be backend really, but major rewrite would be needed
     *
     * @param {*} event
     * @returns {boolean}
     * @memberof ActionMenuController
     */
    ActionMenuController.prototype.ensureApprovalAmountSet = function (event, action) {
        // If all is well it means both bonusTotalCurr and the bonusTotalUSD value should be set
        // TODO: update for calculation v2
        if (angular.isDefined(this.topic.topic.calculation.bonusTotalCurr) && this.topic.topic.calculation.bonusTotalCurr !== '???' &&
            angular.isDefined(this.topic.topic.calculation.bonusTotalUSD)) {
            return true;
        }
        //Kill...
        var items = {
            icon: 'WARN',
            message: 'The Approval Amount in USD does not appear to have been set correctly.  Hover over the red Approval Required icon for details, ' +
                'and reperform the Calculations via the \'Refresh\' button to fix. &nbsp;If that does not resolve the issue, contact the ' +
                'DMT System Administrators for guidance.',
            title: action
        };
        //Block
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            return false;
        });
    };
    ActionMenuController.prototype.checkStageCompleteForApproval = function () {
        var _this = this;
        // some scenarios statusComplete is not getting updated as expected. below is the fall back.
        var status = this.topic.topic.status.status_no;
        if (status !== 4) {
            return false;
        }
        // If calculation node is present, validation has been completed
        if (this.topic.topic.calculation && this.topic.topic.complete.calculation && this.topic.topic.complete.complcl_calculation) {
            return true;
        }
        else {
            // check if all validation sections are completed
            var validThumbSections = ['sap', 'goePick_valid', 'goeCheck_valid', 'complcl_validation',
                'complcl_calculation', 'calculation'];
            var isValidCompleted = validThumbSections.filter(function (secName) { return !_this.topic.topic.complete[secName]; }).length === 0;
            return isValidCompleted;
        }
        return false;
    };
    ActionMenuController.prototype.checkStageComplete = function (event, action) {
        var status = this.topic.topic.status.status_no;
        if (this.topic.topic.complete.statusComplete[status] || (action === 'Submit for Approval' && this.checkStageCompleteForApproval())) {
            return true;
        }
        else {
            //Prepare to ask question...based on event
            var items = {
                icon: 'WARN',
                message: 'Several sections are still to be completed before you can move to the next stage in the process.' +
                    ' &nbsp;Please check for any red thumbs as well as resolving any general errors (ie: pink banner) before attempting again.',
                title: action
            };
            //Block
            this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                return false;
            });
        }
    };
    /**
     * nonAppStatusChange - Function triggered when user changes main status - excluding Approval stages
     *
     * @param  {type} event: any  browser event
     * @param  {type} action: any action event, ie: Initiate Validation, Reject Disbursement etc
    */
    ActionMenuController.prototype.nonAppStatusChange = function (event, action) {
        var _this = this;
        if (!this.checkStageComplete(event, action)) {
            return;
        }
        //Prepare to ask question...based on event
        var items = {
            icon: 'QUESTION',
            message: null,
            title: action
        };
        var isInitalValidation = action === 'Initiate Validation';
        var template = isInitalValidation
            ? 'initiate-validation-dialog.html'
            : 'confirm-prompt.html';
        //Ask it...
        this.Dialog.updateValidForm(event, items, template).then(function (dResult) {
            var incentiveType = '';
            if (isInitalValidation) {
                incentiveType = dResult.locals && dResult.locals.incentiveType;
            }
            var clickedYes = isInitalValidation ? incentiveType : dResult.confirm;
            //If clicked no
            if (!clickedYes) {
                return; //Die
            }
            //Clicked Yes
            //Call initiateValidation code from Status module...will return a bundle
            _this.status.nonAppStatusChange(event, action, _this.topic.topic.status, function (err, statBundle) {
                //If there was an error, ie: Program Profile missing...
                if (statBundle.error) {
                    _this.displayPrompt(event, statBundle, 'ERROR'); //Display error and die
                }
                else {
                    //Update display
                    _this.topic.temp_ext.status = statBundle.nextStatusDesc;
                    _this.topic.temp_ext.sub_status = statBundle.nextSubStatusDesc;
                    _this.topic.temp_ext.sales_assist = incentiveType;
                    //Make call to save
                    _this.status.mainStatusChange = true;
                    _this.saveStatus(statBundle.action, incentiveType);
                }
            });
        });
    };
    /**
     * displayPrompt - Display ok or confirm prompt to user
     *
     * @param  {type} event: any   browser event
     * @param  {type} bundle: any  status bundle
     * @param  {type} icon: string icon to display, ie: INFO, WARN, ERROR
     */
    ActionMenuController.prototype.displayPrompt = function (event, bundle, icon) {
        var items = {
            icon: icon,
            message: bundle.textContent,
            title: bundle.title
        };
        this.Dialog.openDialog(event, items, DialogService, 'confirm-prompt.html');
    };
    /**
     * openActionMenu - Launch action menu dropdown using MD functions
     *
     * @param  {type} $mdOpenMenu: any ngMaterials open menu object
     * @param  {type} event: any       browser event
     */
    ActionMenuController.prototype.openActionMenu = function ($mdOpenMenu, event) {
        var originatorEv = event;
        $mdOpenMenu(event);
    };
    /**
     * showApprovalDialog - Display the Approval Process overlay which will contain instructions,
     * approvers to select, and comments section
     *
     * @param  {type} event: any     browser event
     * @param  {type} appBundle: any approval stage bundle
     * @param  {type} callback: any  callback function to be returned
     * @return {type}                callback containing the contents of the overlay
     */
    ActionMenuController.prototype.showApprovalDialog = function (event, appBundle, callback) {
        //If approving...add user to the approvers list so they are excluded
        if (['Approve', 'Submit for Approval'].indexOf(appBundle.action) > -1) {
            if (angular.isDefined(this.topic.topic.status.approvals.approvers) && this.topic.topic.status.approvals.approvers.indexOf(this.env.user.email) < 0) {
                this.topic.topic.status.approvals.approvers.push(this.env.user.email);
            }
            else {
                this.topic.topic.status.approvals.approvers = [this.env.user.email];
            }
        }
        appBundle.owner = this.topic.topic.owner; //Add assignee
        //appBundle.excludeList = angular.isDefined(this.topic.topic.status.approvals.approvers) ? this.topic.topic.status.approvals.approvers.concat([this.topic.topic.owner]) : [this.topic.topic.owner]; //Previous approvers and assignee                
        appBundle.excludeList = angular.isDefined(this.topic.topic.status.approvals.approvers) ? this.topic.topic.status.approvals.approvers : []; //Previous approvers
        appBundle.nextStatusObject.users = this.status.cleanApprovers(appBundle.nextStatusObject.users, appBundle.excludeList);
        var title = 'The following users have already approved during the current Approval Process:\n';
        for (var i = 0; i < appBundle.excludeList.length - 1; i++) {
            title += '\n# ' + (i + 1) + ' ' + appBundle.excludeList[i];
            if (i === 0) {
                title += ' - (initiated by)';
            }
        }
        appBundle.prevApprovers = title;
        var items = {
            appBundle: appBundle
        };
        this.Dialog.updateValidForm(event, items, 'approval-dialog.html').then(function (dResult) {
            //Check dialog result var...
            if (!angular.isUndefined(dResult)) {
                return callback(dResult.locals.appBundle);
            }
        });
    };
    ActionMenuController.prototype.finaliseAppStage = function (appBundle, action) {
        //If approver selected and differs from current one (if any)
        if (appBundle.select_approver) {
            if (!appBundle.selected_approver ||
                (appBundle.selected_approver && appBundle.selected_approver.name !== appBundle.select_approver)) {
                //Need to work out email for new approver
                angular.forEach(appBundle.nextStatusObject.users, function (approver) {
                    if (approver.name === appBundle.select_approver) {
                        appBundle.selected_approver = {
                            name: approver.name,
                            email: approver.email
                        };
                    }
                });
            }
        }
        //Update display
        this.topic.temp_ext.status = appBundle.nextStatusDesc;
        this.topic.temp_ext.sub_status = appBundle.nextSubStatusDesc;
        if (appBundle.approvalComplete || this.status.isRollBackAction(action)) {
            this.topic.temp.status.approvals.approval_profile = ''; //Wipe
            this.topic.temp.status.approvals.selected_approver_name = '';
            this.topic.temp.status.approvals.selected_approver_email = '';
        }
        else {
            this.topic.temp.status.approvals.approval_profile = appBundle.nextStatus + '-' + appBundle.nextSubStatus; //Wipe
            this.topic.temp.status.approvals.selected_approver_name = appBundle.selected_approver.name;
            this.topic.temp.status.approvals.selected_approver_email = appBundle.selected_approver.email;
        }
        appBundle.owner = this.topic.topic.owner;
        this.status.appBundle = appBundle; //Set locally so it can be retrieved for email later
        this.status.mainStatusChange = true;
        this.saveStatus(appBundle.action, appBundle.comments);
    };
    ActionMenuController.prototype.saveStatus = function (action, comments) {
        // This needs to be changed in order for the substatus to work nicely
        this.topic.sendForUpdate(['status', 'sales_assist'], action, comments, false);
        //If sending for Initiate Validation and 2nd GOE is gonna be fired, set the socket so the button is disabled
        //if (action === 'Initiate Validation' && this.topic.is2ndGOENeeded()) {
        //this.topic.updatePartialSocketStatus(['cmr_valid'], 'Updating'); //Wouldn't work
        //    this.topic.goeFired = true;
        //}
    };
    ActionMenuController.prototype.app = function (event, action) {
        var _this = this;
        if (action === 'Submit for Approval' && !this.checkStageComplete(event, action)) {
            return;
        }
        if (action === 'Submit for Approval' && !this.ensureApprovalAmountSet(event, action)) {
            return;
        }
        this.status.disableApproveButtons = true;
        this.status.appBundle = null;
        var topicBundle = {
            country: this.topic.topic.country,
            program: this.topic.topic.program,
            status: this.topic.topic.status
        };
        //Call approval process to build the bundle
        //let appBundle: any = this.status.approvalProcess(event, action, this.topic.topic.status);
        this.status.approvalProcess(event, action, topicBundle, function (err, appBundle) {
            _this.status.disableApproveButtons = false;
            //If there was an error, ie: Program Profile missing...
            if (appBundle.error) {
                _this.displayPrompt(event, appBundle, 'ERROR'); //Display error and die
            }
            else {
                //Display dialog with appropriate messages etc
                _this.showApprovalDialog(event, appBundle, function (appBundle) {
                    _this.finaliseAppStage(appBundle, action);
                });
            }
        });
    };
    ActionMenuController.prototype.updateSubstatusSetAside = function (docId, flag, invoice_flags, turnOn) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    docId: docId,
                    flag: flag,
                    invoice_flags: invoice_flags,
                    turnOn: turnOn
                },
                bID: this.topic.topicBrowserID,
                function: 'substatusUpdate',
                scopeBack: this.scopeUpdateSubstatus,
                script: this.invFlagUpdateBackendModuleName,
                token: this.env.user.token,
                email: this.env.user.email
            }
        });
        return;
    };
    ActionMenuController.prototype.refreshSiteIds = function () {
        this.socket.emit('module', {
            module: {
                data: {
                    opportunityId: this.topic.topic._id
                },
                //bID: this.topic.topicBrowserID,
                className: 'SiteIdGate',
                function: 'refreshSiteIdDataClient',
                //scopeBack: 'eligibility.refreshSiteIds',
                script: 'dswSiteId/siteIdGate',
                token: this.env.user.token
            }
        });
        return;
    };
    ActionMenuController.prototype.changeInvFlag = function (event, flag) {
        //flag 0 -> the invoice requested, flag 1 -> the invoice received
        var turnOn;
        if (flag === 0) {
            if (!this.topic.topic.version || this.topic.topic.version < this.OPP_VERSION_3) {
                if (!this.topic.topic.invoice_flags.requested && !this.topic.topic.eu_check) {
                    this.displayPrompt(event, { textContent: 'Unable to raise this flag when "End User Check" is not "Yes".', title: 'Flag setting error' }, 'ERROR');
                    return;
                }
                //#1774 - no need for this check
                // if (this.topic.topic.invoice_flags.requested && this.topic.topic.eu_check.decision === 'Yes') {
                //     this.displayPrompt(event, { textContent: 'Unable to remove this flag when "End User Check" is "Yes".', title: 'Flag setting error' }, 'ERROR');
                //     return;
                // }
                if (!this.topic.topic.invoice_flags.requested && this.topic.topic.eu_check.decision !== 'Yes') {
                    this.displayPrompt(event, { textContent: 'Unable to raise this flag when "End User Check" is not "Yes".', title: 'Flag setting error' }, 'ERROR');
                    return;
                }
            }
            if (this.topic.topic.invoice_flags.requested && (this.topic.topic.invoice_flags.received || this.topic.topic.invoice_flags.submitted)) {
                this.displayPrompt(event, { textContent: 'Unable to remove this flag when "Invoice Received Flag" or "Submitted to Accounts Payable" are raised.', title: 'Flag removal error' }, 'ERROR');
                return;
            }
            this.topic.topic.invoice_flags.requested = !this.topic.topic.invoice_flags.requested;
            if (this.topic.topic.invoice_flags.requested) {
                this.topic.topic.invoice_flags.requestedTimestamp = new Date().getTime();
                this.topic.topic.invoice_flags.requestedFlaggedBy = this.env.user.email;
            }
            else {
                this.topic.topic.invoice_flags.requestedTimestamp = null;
                this.topic.topic.invoice_flags.requestedFlaggedBy = null;
            }
            turnOn = this.topic.topic.invoice_flags.requested;
        }
        else if (flag === 1) {
            if (!this.topic.topic.invoice_flags.received && !this.topic.topic.invoice_flags.requested) {
                this.displayPrompt(event, { textContent: 'Unable to raise this flag when "Invoice Requested Flag" is not raised.', title: 'Flag setting error' }, 'ERROR');
                return;
            }
            if (this.topic.topic.invoice_flags.received && this.topic.topic.invoice_flags.submitted) {
                this.displayPrompt(event, { textContent: 'Unable to remove this flag when "Submitted to Accounts Payable" is raised.', title: 'Flag removal error' }, 'ERROR');
                return;
            }
            this.topic.topic.invoice_flags.received = !this.topic.topic.invoice_flags.received;
            if (this.topic.topic.invoice_flags.received) {
                this.topic.topic.invoice_flags.receivedTimestamp = new Date().getTime();
                this.topic.topic.invoice_flags.receivedFlaggedBy = this.env.user.email;
            }
            else {
                this.topic.topic.invoice_flags.receivedTimestamp = null;
                this.topic.topic.invoice_flags.receivedFlaggedBy = null;
            }
            turnOn = this.topic.topic.invoice_flags.received;
        }
        else if (flag === 2) {
            if (!this.topic.topic.version || this.topic.topic.version < this.OPP_VERSION_3) {
                if (this.topic.topic.iot === 'North America IOT' && (this.topic.topic.eu_check === undefined || this.topic.topic.eu_check.decision !== 'Yes')) {
                    this.displayPrompt(event, { textContent: 'Unable to raise this flag when "End User Check" is not "Yes".', title: 'Flag setting error' }, 'ERROR');
                    return;
                }
            }
            if (!this.topic.topic.invoice_flags.submitted && (!this.topic.topic.invoice_flags.requested || !this.topic.topic.invoice_flags.received)) {
                this.displayPrompt(event, { textContent: 'Unable to raise this flag when "Invoice Requested Flag" or "Invoice Received Flag" are not raised.', title: 'Flag setting error' }, 'ERROR');
                return;
            }
            this.topic.topic.invoice_flags.submitted = !this.topic.topic.invoice_flags.submitted;
            // end user editable mode is updated in detail.payment.eu.check.component.ts by broadcast event sent when topic is updated
            if (this.topic.topic.invoice_flags.submitted) {
                this.topic.topic.invoice_flags.submittedTimestamp = new Date().getTime();
                this.topic.topic.invoice_flags.submittedFlaggedBy = this.env.user.email;
            }
            else {
                // if (this.topic.topic.iot === 'North America IOT' && this.topic.editableComponents && (this.topic.editableComponents.eu_check === undefined || (this.topic.editableComponents.eu_check.editable === false))) {
                //     this.topic.editableComponents.eu_check = { editable: true, editMode: false, socket: '' };
                // }
                this.topic.topic.invoice_flags.submittedTimestamp = null;
                this.topic.topic.invoice_flags.submittedFlaggedBy = null;
            }
            turnOn = this.topic.topic.invoice_flags.submitted;
        }
        this.updateSubstatusSetAside(this.topic.topic._id, flag, this.topic.topic.invoice_flags, turnOn);
    };
    //Roman Tibensky  20171017, Card 789 : Sales Assist flag - Sys Admin function
    ActionMenuController.prototype.changeSalesAssist = function (event) {
        var _this = this;
        var salesOptionLabel = this.getNewUIInfo.uiVersion >= 4 ? 'Sales' : 'CVR Sales';
        var salesAssistOptionLabel = this.getNewUIInfo.uiVersion >= 4 ? 'Sales Assist' : 'CVR Sales Assist';
        var saFlagArray = [
            salesAssistOptionLabel,
            salesOptionLabel,
            'Automatic',
            'NO FLAG',
        ];
        var currentFlag = (this.topic.topic.sales_assist && this.topic.topic.sales_assist.type) ? this.topic.topic.sales_assist.type : 'Automatic';
        var items = { saFlags: saFlagArray, saFlag: currentFlag, original: currentFlag };
        items.saFlags.splice(saFlagArray.indexOf(currentFlag), 1);
        items.saFlag = items.saFlags[0];
        this.Dialog.updateValidForm(undefined, items, 'set-sa-flag-dialog.html').then(function (dResult) {
            if (dResult.confirm) {
                // Set history description
                var desc = 'Incentive Type changed from \'' + currentFlag + '\' to \'' + dResult.saFlag + '\'';
                if (_this.topic.temp.sales_assist && _this.topic.temp.sales_assist.type) {
                    _this.topic.temp.sales_assist.type = dResult.saFlag;
                }
                else {
                    _this.topic.temp.sales_assist = {
                        type: dResult.saFlag
                    };
                }
                // Get history entry
                var newHistory = _this.status.getNewHistoryObject('Incentive Type Change', desc, '-', dResult.comment);
                // Prepare object for $10k
                var data = {
                    id: _this.topic.topic._id,
                    data: (_a = {},
                        _a['sales_assist'] = {
                            add: true,
                            data: _this.topic.temp.sales_assist
                        },
                        _a['status.history'] = {
                            push: true,
                            data: [newHistory]
                        },
                        _a
                    ),
                    type: ['sales_assist', 'status']
                };
                // Send for update
                _this.topic.updateServerTopic('couchUpdate', data, true);
            }
            var _a;
        });
    };
    ActionMenuController.prototype.copyOppData = function (event) {
        alert('DEPRECATED');
        //     const data: { inCurrentStatus: boolean, disputes: string[], choosedDispute: string } = {
        //         choosedDispute: undefined,
        //         disputes: this.topic.topic.disputes,
        //         inCurrentStatus: true,
        //     };
        //     this.Dialog.updateValidForm(event, data, 'copy-uat-dialog.html').then((dResult: any) => {
        //         const dataReq: any = {
        //             dispute: dResult.locals.choosedDispute,
        //             disputes: this.topic.topic.disputes,
        //             inCurrentStatus: dResult.locals.inCurrentStatus,
        //             oppId: this.topic.topic._id,
        //         };
        //         this.socket.emit('module', {
        //             module: {
        //                 application: 'dmt',
        //                 data: dataReq,
        //                 function: 'copyOppData',
        //                 script: '/config/config',
        //                 user: this.env.user
        //             },
        //         });
        //     });
    };
    ActionMenuController.prototype.isVersion4AndMore = function () {
        return this.topic.topic.version > 3;
    };
    ActionMenuController.prototype.isVersion5AndMore = function () {
        return this.topic.topic.version > 4;
    };
    ActionMenuController.$inject = ['config', 'Dialog', 'status', 'topic', '$state', 'settings', 'env', 'socket', '$scope', 'admin', 'notify'];
    return ActionMenuController;
}());
var ActionMenuComponent = (function () {
    function ActionMenuComponent() {
        this.templateUrl = 'action-menu.html';
        this.controllerAs = 'vm';
        this.controller = ActionMenuController;
    }
    return ActionMenuComponent;
}());
angular
    .module('application')
    .component('actionMenu', new ActionMenuComponent());

//# sourceMappingURL=action-menu-component.js.map
